export default __webpack_public_path__ + "static/media/cal.7ac29ecf.svg";